var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Signup page "),_c('b-button',{attrs:{"to":{ name: 'login' }}},[_vm._v(" Back to Login ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }